import Utils from './Utils';
let loaded = false;

export async function loadStripeOnce() {
  if (loaded) return;
  loaded = true;
  await Utils.loadScript('https://js.stripe.com/v3')
}
